import {defineStore} from 'pinia';
import api from '../api/medsenger_api.js'
import User from "@/models/user.js";
import Clinic from "@/models/clinic.js";
import {emitter} from "@/infrastructure/event_bus.js";

export const useOnlineUsersStore = defineStore('onlineUsers', {
    state: () => ({
        online_user_ids: new Set(),
        initialized: false,
    }),

    getters: {
        onlineIds() {
            return [...this.online_user_ids]
        },
        onlineIdsSet() {
            return this.online_user_ids
        }
    },

    actions: {
        async initializeStore() {
            if (this.initialized) return;
            this.initialized = true

            emitter.on('socketEvent', this.processEvent)
            console.log('Online users store initialized')
        },

        processEvent(event) {
            console.log('Got event', event)
            if (event.type === 'onlineUsers') {
                this.online_user_ids = new Set(event.payload)
            }

            if (event.type === 'userOnline') {
                this.online_user_ids.add(event.payload)
            }

            if (event.type === 'userOffline') {
                this.online_user_ids.delete(event.payload)
            }
        }
    },
});